<template>
  <div v-ripple class="op-icon-text-btn" :style="[!noWrap ? { width: `${width}px` } : { 'white-space': 'nowrap' }]" @click="$emit('onClick')" :title="hint">
    <v-icon class="op-btn-icon" :color="iconColor" :disabled="disabled" :small="small" :xSmall="xSmall"> {{ icon }} </v-icon>

    <div
      v-if="!iconOnly"
      :class="`${iconColor}--text`"
      class="op-btn-text op-text-sm"
      :style="[!noWrap ? { width: `${width}px` } : { 'white-space': 'nowrap' }]"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
    hint: String,
    width: { type: Number, default: 70 },
    small: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    iconColor: { type: String, default: 'white' },
    disabled: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    noWrap: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.op-icon-text-btn {
  height: 50px;
  display: flex;
  flex-direction: column;
  /* pointer-events on appBar disables pull-to-refresh and all touch / mouse events. Therefore all elements on top need to have explicitly set the pointer-events to auto */
  pointer-events: auto;
  cursor: pointer;
}

.op-btn-icon {
  height: 27px;
  transition: all 0.5s;
  padding-bottom: 4px;
  display: flex !important;
  flex-direction: column;
  justify-content: center !important;
  text-align: center;
}

.op-btn-text {
  height: 28px;
  /*transition: all 0.5s;*/
  /* font-size: 0.9em !important; */
  white-space: normal;
  flex-wrap: wrap;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;

  line-height: 1.1;
}
</style>
